import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import {
  Grid,
  TextField,
  Button,
  Box,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import axios from "axios";
import apiService from "../../utils/apiservice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//import apiService from "../../utils/apiservice";
import "./Create_Parameter.css";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;


const Create_Parameter = () => {
  const [paramData, setParamData] = useState({
    display_name: "",
    key_name: "",

    parameter_type: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [keyOptions, setKeyOptions] = useState([]);

  // ✅ MODAL STATE
  const [openModal, setOpenModal] = useState(false);

  // ✅ LEVEL TYPE
  const [levelValueType, setLevelValueType] = useState("");

  const navigate = useNavigate();

  const typeOptions = ["Label", "Guages", "Tank"];


  // ✅ Display Name (same as device name but max 20)
  const displayNameRegex = /^[A-Za-z0-9]+( [A-Za-z0-9]+)*$/;

// ✅ Key Name (lowercase + _ and - only, 4–12 chars)
const keyNameRegex = /^[A-Za-z_-]{4,12}$/;
const onlyNumbersRegex = /^[0-9]+$/;

 const validateField = (name, value) => {
  let error = "";

  if (name === "display_name") {
    if (!value) {
      error = "Display name is required";
    } else if (value.length < 2 || value.length > 30) {
      error = "Must be 2–30 characters";
    } else if (onlyNumbersRegex.test(value)) {
      error = "Cannot be only numbers";
    } else if (!displayNameRegex.test(value)) {
      error =
        "Only letters & numbers, single spaces, no leading/trailing spaces";
    }
  }

  // if (name === "key_name") {
  //   if (!value) {
  //     error = "Key name is required";
  //   } else if (!keyNameRegex.test(value)) {
  //     error = "4–12 chars, allowed: _ and - (no spaces)";
  //   }
  // }

  if (name === "parameter_type") {
    if (!value) {
      error = "Parameter Type is required";
    }
  }

  return error;
};

  // ✅ VALIDATION
  // const validateForm = () => {
  //   const tempErrors = {};
  //   const { display_name, key_name, parameter_type } = paramData;


  //   if (!display_name || display_name.trim().length < 2) {
  //     tempErrors.display_name = "Display Name must be at least 2 characters.";
  //   }

  //   if (!key_name || !/^[a-z0-9_]{2,30}$/.test(key_name)) {

  //     tempErrors.key_name =
  //       "Key Name must be 2-30 characters (lowercase & underscores only).";
  //   }

  //   if (!parameter_type) {
  //     tempErrors.parameter_type = "Parameter Type is required";
  //   }

  //   // ✅ LEVEL VALIDATION
  //   if (parameter_type === "Level" && !levelValueType) {
  //     toast.error("Please select level type");
  //     return false;

  //   }

  //   setErrors(tempErrors);
  //   return Object.keys(tempErrors).length === 0;
  // };

  // ✅ HANDLE CHANGE
  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    // ✅ Fix spaces for display name
    if (name === "display_name") {
      updatedValue = value
        .replace(/\s+/g, " ")   // multiple → single
        .replace(/^\s/, "");    // remove starting space
    }

  // ❌ Prevent spaces in key_name
  // if (name === "key_name") {
  //   updatedValue = value.replace(/\s/g, "");
  // }

    setParamData((prev) => ({
      ...prev,
      [name]: updatedValue
    }));

    // ✅ Runtime validation
    const error = validateField(name, updatedValue);

    setErrors((prev) => ({
      ...prev,
      [name]: error
    }));

    // ✅ OPEN MODAL FOR LEVEL
    if (name === "parameter_type" && value === "Label") {
      setOpenModal(true);
    }
  };



  // ✅ SUBMIT
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // ✅ Validate all fields once
    const newErrors = {};

  Object.keys(paramData).forEach((key) => {
    const error = validateField(key, paramData[key]);
    if (error) newErrors[key] = error;
  });

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    toast.error("Please fix errors before submitting");
    return;
  }

  // ✅ Level check
  if (paramData.parameter_type === "Label" && !levelValueType) {
    toast.error("Please select Label type");
    return;
  }

  try {
    setLoading(true);

    const token = localStorage.getItem("accessToken");

    // const response = await axios({
    //   url: `${API_URL}/api/create_parameter/`,
    //   method: "POST",
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //     Accept: "application/json",
    //     "Content-Type": "application/json",
    //   },
    //   data: {
    //     ...paramData,
    //     level_value_type: levelValueType,
    //   },
    // });

   

      const response = await apiService({
        url: `/api/create_parameter/`,
        method: "POST",
        data: {
          ...paramData,
          level_value_type: levelValueType,
        },
      });

      toast.success("Parameter created successfully");

      setParamData({
        display_name: "",
        key_name: "",
        parameter_type: "",
      });

      setLevelValueType("");
      setErrors({});

    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to create parameter");
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    fetchKeyNames();
  }, []);






const fetchKeyNames = async () => {
  try {
    const token = localStorage.getItem("accessToken");

    const res = await axios.get(
      `${API_URL}/api/get_pending_keynames/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setKeyOptions(res.data.data); // contains key_name
  } catch (error) {
    toast.error("Failed to fetch key names");
  }
};




  return (
    <Box
      component="form"
      className="create-param-form-container"
      onSubmit={handleFormSubmit}
    >
      <Grid container spacing={3}>

        {/* Display Name */}
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Display Name"
            name="display_name"
            value={paramData.display_name}
            onChange={handleChange}
            error={!!errors.display_name}
            helperText={errors.display_name || ""}
          />
        </Grid>

        {/* Key Name */}
        <Grid item xs={12} sm={6}>
  <TextField
    select
    fullWidth
    label="Key Name"
    name="key_name"
    value={paramData.key_name}
    onChange={handleChange}
    error={!!errors.key_name}
    helperText={errors.key_name || ""}
  >
    {keyOptions.map((item) => (
      <MenuItem key={item.key_name} value={item.key_name}>
        {item.key_name}
      </MenuItem>
    ))}
  </TextField>
</Grid>

        {/* Parameter Type */}
        <Grid item xs={12} sm={6}>
          <TextField
            select
            fullWidth
            label="Parameter Type"
            name="parameter_type"
            value={paramData.parameter_type}
            onChange={handleChange}
            error={!!errors.parameter_type}
            helperText={errors.parameter_type || ""}
          >
            {typeOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

      </Grid>

      {/* BUTTONS */}
      <Box sx={{ mt: 4, display: "flex", gap: 2, justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          onClick={() => {
            setParamData({
              display_name: "",
              key_name: "",
              parameter_type: "",
            });
            setLevelValueType("");
            setErrors({});
            navigate("/dashboard");
          }}
        >
          Cancel
        </Button>

        <Button type="submit" variant="contained" disabled={loading}>
          {loading ? "Creating..." : "Create Parameter"}
        </Button>
      </Box>

      <ToastContainer position="top-right" autoClose={3000} />

      {/* ✅ MODAL */}
      <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth>
        <DialogTitle>Select Type</DialogTitle>

        <DialogContent>
          <TextField
            select
            fullWidth
            label="Select Type"
            value={levelValueType}
            onChange={(e) => setLevelValueType(e.target.value)}
            sx={{ mt: 2 }}
          >
            {/* <MenuItem value="Online/Offline">Online / Offline</MenuItem> */}
            <MenuItem value="Auto/Manual (1/0)">Auto / Manual (1/0)</MenuItem>
            <MenuItem value="Active/Inactive (1/0)">Active / Inactive (1/0)</MenuItem>
            <MenuItem value="On/Off (1/0)">On / Off (1/0)</MenuItem>
             <MenuItem value="Manual/Auto (0/1)">Manual / Auto (0/1)</MenuItem>
              <MenuItem value="Inactive/Active (0/1)">Inactive / Active (0/1)</MenuItem>
               <MenuItem value="Off/On (0/1)">Off / On (0/1)</MenuItem>
          </TextField>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => {
              if (!levelValueType) {
                toast.error("Please select type");
                return;
              }
              setOpenModal(false);
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default Create_Parameter;